import { takeEvery, put, all, call } from 'redux-saga/effects';
import * as types from './backofficeUserActionTypes';
import * as actions from './backofficeUserActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';
import { errorHandler } from '../../helpers/errorHandler';
function* getBackofficeUserSaga(action) {
  try {
    const { data } = yield call(endpoints.getBackofficeUsers);
    console.log('BackofficeUsers:')
    console.log(data)
    yield put(actions.getBackofficeUsersActionData(data));
  } catch (e) {
    errorHandler(e)
    yield put(actions.getBackofficeUsersActionError(e));
  }
}
function* createBackofficeUserSaga(action) {
  try {
    const { body } = action.payload;
    console.log(body);
    const { data } = yield call(endpoints.createBackofficeUser, body);
    yield put(actions.createBackofficeUserActionData(data));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e)
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.createBackofficeUserActionError(e));
  }
}

function* updateBackofficeUserSaga(action) {
  try {
    const { userID, body } = action.payload;
    console.log(userID);
    console.log(body);
    const { data } = yield call(endpoints.updateBackofficeUser, userID, body);
    console.log(data);
    yield put(actions.updateBackofficeUserActionData(data));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e) //TEST
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.updateBackofficeUserActionError(e));
  }
}

function* resendBackofficeActivationEmailSaga(action) {
  try {
    const { userID } = action.payload;
    const { data } = yield call(endpoints.resendBackofficeActivationEmail, userID);

    yield put(actions.resendBackofficeActivationEmailActionData(data));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e);
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message || e?.response?.data?.detail,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.resendBackofficeActivationEmailActionError(e));
  }
}

function* watchGetBackofficeUser() {
  yield takeEvery(types.GET_BACKOFFICEUSERS_REQUEST, getBackofficeUserSaga);
}
function* watchCreateBackofficeUser() {
  yield takeEvery(types.CREATE_BACKOFFICEUSER_REQUEST, createBackofficeUserSaga);
}

function* watchUpdateBackofficeUser() {
  yield takeEvery(types.UPDATE_BACKOFFICEUSER_REQUEST, updateBackofficeUserSaga);
}

function* watchResendBackofficeActivationEmail() {
  yield takeEvery(
    types.RESEND_BACKOFFICEUSER_ACTIVATION_EMAIL_REQUEST,
    resendBackofficeActivationEmailSaga
  );
}

export function* backofficeUserSaga() {
  yield all([
    watchGetBackofficeUser(),
    watchCreateBackofficeUser(),
    watchUpdateBackofficeUser(),
    watchResendBackofficeActivationEmail(),
  ]);
}
